import React, { useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import styled from 'styled-components/native';

import ClientContext from 'app/src/contexts/ClientContext';
import DataState from 'app/src/elements/DataState';
import Modal from 'app/src/elements/Modal';
import { Text } from 'app/src/styles';
import { ActionText } from 'app/src/styles/table';
import { datetimeShort, truncate } from 'app/src/utils/formatting';

import UserLog from './UserLog';
import { USER_HISTORY } from './queries';

const Data = styled(View)`
  flex-direction: ${props => props.isMobile ? 'column' : 'row'};
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #d0d0d0;
`;

const Label = styled(Text)`
  width: 320px;
  font-weight: 600;
`;

const Value = styled(Text)`
`;

const baseColumns = [
  {
    key: 'createdAt',
    label: 'Time',
    content: datetimeShort,
  },
  {
    key: 'action',
    label: 'Action',
    value: ({ entry }) => `${entry.controller}#${entry.action}`,
  },
  {
    key: 'graphqlOperation',
    label: 'Operation',
  },
  {
    key: 'graphqlVariables',
    label: 'Variables',
    content: ({ value }) => truncate(value, { limit: 40 }),
  },
];

const UserHistory = ({ user }) => {
  const { isMobile } = useContext(ClientContext);
  const [showUserLog, setShowUserLog] = useState();

  const { data, ...dataState } = useQuery(
    USER_HISTORY, { variables: { id: user.id }, fetchPolicy: 'no-cache' }
  );

  const history = data?.userHistory;

  const columns = [
    ...baseColumns,
    {
      key: 'actions',
      label: 'Actions',
      sort: 'prevent',
      content: ({ entry }) => (
        <Pressable onPress={() => setShowUserLog(entry)}>
          <ActionText>View</ActionText>
        </Pressable>
      ),
    }
  ];

  return (
    <DataState data={data} {...dataState}>
      {history && (
        <View>
          <Text>
            This is timestamps and such that might be helpful in figuring out
            login issues.
          </Text>

          <Data isMobile={isMobile} style={{ marginTop: 6 }}>
            <Label>ID</Label>
            <Value>{user.id}</Value>
          </Data>

          <Data isMobile={isMobile} style={{ marginTop: 6 }}>
            <Label>Created</Label>
            <Value>{datetimeShort(history.createdAt)}</Value>
          </Data>

          <Data isMobile={isMobile}>
            <Label>Invitation Sent</Label>
            <Value>{datetimeShort(history.invitationSentAt)}</Value>
          </Data>

          <Data isMobile={isMobile}>
            <Label>Invitation Accepted</Label>
            <Value>{datetimeShort(history.invitationAcceptedAt)}</Value>
          </Data>

          <Data isMobile={isMobile}>
            <Label>Email Confirmed</Label>
            <Value>{datetimeShort(history.confirmedAt)}</Value>
          </Data>

          <Data isMobile={isMobile}>
            <Label>Password Last Changed</Label>
            <Value>{datetimeShort(history.passwordChangedAt)}</Value>
          </Data>

          <Data isMobile={isMobile}>
            <Label>Reset Password Code Last Requested</Label>
            <Value>{datetimeShort(history.resetPasswordSentAt)}</Value>
          </Data>

          <Data isMobile={isMobile}>
            <Label>Two Factor Code Last Sent</Label>
            <Value>{datetimeShort(history.otpSentAt)}</Value>
          </Data>

          <Data isMobile={isMobile}>
            <Label>Last Devise Activity</Label>
            <Value>{datetimeShort(history.lastActivityAt)}</Value>
          </Data>

          <Text style={{ fontWeight: 600, marginTop: 12 }}>Recent User Logs</Text>

          <DataTable.Simple
            data={history.recentUserLogs}
            columns={columns}
            pageLength="All"
          />
        </View>
      )}

      {showUserLog && (
        <Modal title="User Log" setShow={setShowUserLog}>
          <UserLog setShow={setShowUserLog} userLog={showUserLog} />
        </Modal>
      )}
    </DataState>
  );
};

export default UserHistory;
